<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">
                    <!-- Linha 1 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Contrato Juridico
                                </mat-label>
                                <input matInput id="txtContrato" #txtContrato maxlength="20"
                                    formControlName="contrato_juridico" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtContrato.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.contrato_juridico)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Cooperante
                                </mat-label>
                                <input matInput id="txtCoop" #txtCoop maxlength="20"
                                    formControlName="cooperante">
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtCoop.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.cooperante)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Hibrido
                                </mat-label>
                                <input matInput id="txtRnc" #txtRnc maxlength="20"
                                    formControlName="hibrido_rnc" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtRnc.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.hibrido_rnc)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Origem
                                </mat-label>
                                <input matInput id="txtSiteOrigem" #txtSiteOrigem maxlength="20"
                                    formControlName="site_origem" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtSiteOrigem.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.site_origem)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    
                    <!-- Linha 2 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Gleba
                                </mat-label>
                                <input matInput id="txtGleba" #txtGleba maxlength="20"
                                    formControlName="gleba" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtGleba.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.gleba)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Distancia Campo
                                </mat-label>
                                <input matInput id="txtDisCamp" #txtDisCamp maxlength="20"
                                    formControlName="distancia_campo" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtDisCamp.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.distancia_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Especie
                                </mat-label>
                                <input matInput id="txtEsp" #txtEsp maxlength="20"
                                    formControlName="especie" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtEsp.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.especie)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tipo Colheita
                                </mat-label>
                                <input matInput id="txtTpColheita" #txtTpColheita maxlength="20"
                                    formControlName="tipo_colheita" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtTpColheita.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tipo_colheita)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    
                    <!-- Linha 3 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Numero Campo
                                </mat-label>
                                <input matInput id="txtNumCamp" #txtNumCamp maxlength="20"
                                    formControlName="numero_campo" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtNumCamp.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.numero_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Safra
                                </mat-label>
                                <input matInput id="txtSafra" #txtSafra maxlength="20"
                                    formControlName="safra" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtSafra.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.safra)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ano
                                </mat-label>
                                <input matInput id="txtAno" #txtAno maxlength="4"
                                    formControlName="ano" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtAno.value.length}} / 4</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.ano)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">JIT
                                </mat-label>
                                <input matInput id="txtJit" #txtJit maxlength="20"
                                    formControlName="jit" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtJit.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.jit)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    
                    <!-- Linha 4 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Contrato Torre
                                </mat-label>
                                <input matInput id="txtContratoTorre" #txtContratoTorre maxlength="20"
                                    formControlName="contrato_torre" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtContratoTorre.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.contrato_torre)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Geração
                                </mat-label>
                                <input matInput id="txtGeracao" #txtGeracao maxlength="20"
                                    formControlName="geracao" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtGeracao.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.geracao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Origem Contrato
                                </mat-label>
                                <input matInput id="txtOrgContrato" #txtOrgContrato maxlength="20"
                                    formControlName="origem_contrato" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtOrgContrato.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.origem_contrato)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 5 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Janela Plantio
                                </mat-label>
                                <input matInput id="txtJanelaPl" #txtJanelaPl maxlength="20"
                                    formControlName="janela_plantio" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtJanelaPl.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.janela_plantio)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ambiente
                                </mat-label>
                                <input matInput id="txtAmb" #txtAmb maxlength="20"
                                    formControlName="ambiente" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtAmb.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.ambiente)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Recebimento
                                </mat-label>
                                <input matInput id="txtSiteReceb" #txtSiteReceb maxlength="20"
                                    formControlName="site_recebimento" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtSiteReceb.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.site_recebimento)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
              

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>